import "@/App.css";
import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import { hasPaidAccess } from "@/lib/access";
import Landing from "@/pages/Landing";
import Dashboard from "@/pages/Dashboard";
import Videos from "@/pages/Videos";
import Subscribe from "@/pages/Subscribe";
import Admin from "@/pages/Admin";
import Account from "@/pages/Account";

const LoadingScreen = () => (
    <div className="flex min-h-screen items-center justify-center bg-black text-white/60">
        Loading…
    </div>
);

const ProtectedRoute = ({ children }) => {
    const { isAuthenticated, loading } = useAuth();
    if (loading) return <LoadingScreen />;
    if (!isAuthenticated) return <Navigate to="/" replace />;
    return children;
};

// Requires authentication AND an active subscription (or admin grant). Umbrella
// mode removed the per-user Submagic onboarding step.
const SubscribedRoute = ({ children }) => {
    const { user, isAuthenticated, loading } = useAuth();
    if (loading) return <LoadingScreen />;
    if (!isAuthenticated) return <Navigate to="/" replace />;
    if (!hasPaidAccess(user)) return <Navigate to="/subscribe" replace />;
    return children;
};

function App() {
    return (
        <div className="App">
            <AuthProvider>
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<Landing />} />
                        <Route
                            path="/subscribe"
                            element={
                                <ProtectedRoute>
                                    <Subscribe />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/dashboard"
                            element={
                                <SubscribedRoute>
                                    <Dashboard />
                                </SubscribedRoute>
                            }
                        />
                        <Route
                            path="/videos"
                            element={
                                <SubscribedRoute>
                                    <Videos />
                                </SubscribedRoute>
                            }
                        />
                        <Route
                            path="/account"
                            element={
                                <ProtectedRoute>
                                    <Account />
                                </ProtectedRoute>
                            }
                        />
                        <Route path="/admin" element={<Admin />} />
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                    <Toaster
                        position="top-center"
                        theme="dark"
                        toastOptions={{
                            style: {
                                background: "var(--rf-surface-raised)",
                                border: "1px solid rgba(255,255,255,0.1)",
                                color: "#fff",
                            },
                        }}
                    />
                </BrowserRouter>
            </AuthProvider>
        </div>
    );
}

export default App;
